<header class="header-desktop" *ngIf="!isEmbed">
  <div class="row-header">
    <div class="column-1 d-flex flex-column">
      <img class="link_home_logo_header" src="../../assets/images/logo-solocal.svg" alt="" width="160" height="auto">
      <span class="profile-info" (click)="goToAdminPages()" [ngClass]="userRole == '' ? 'invisible' : ''">> {{'Connected as' | translate}} {{userRole | translate}} {{"to account" | translate}} {{customerId}}</span>
    </div>

    <div class="column-2">
      <span class="cdc-toolbar-message">
        {{
  (manager !== undefined && manager !== '' && manager !== null)
    ? ('I contact my dedicated advisor {0} on ' | translate: { '0': manager })
    : ('I contact client service on ' | translate)
        }}
        <span class="phone-number">34 01</span>
      </span>
      <span class="cdc-label-description m-0 cdc-toolbar-info">{{'Free service + call price' | translate}}</span>
    </div>
  </div>
</header>
<header class="header-mobile" *ngIf="!isEmbed">
  <div class="row-header">
    <div class="column-1">
      {{
        (manager !== undefined && manager !== '')
          ? ('I contact my dedicated advisor {0} on ' | translate: { '0': manager }) + '34 01'
          : ('I contact client service on ' | translate) + '34 01'
      }}
      <section>
        <a href="tel:3401" mat-icon-button class="phone-button round-button"><mat-icon>phone</mat-icon></a>
      </section>
    </div>
    <div class="column-2">
      <div class="d-flex flex-column">
        <img class="link_home_logo_header" src="../../assets/images/logo-solocal.svg" alt="" width="180" height="auto">
        <span class="profile-info" (click)="goToAdminPages()" *ngIf="userRole != ''">> {{userRole | translate}} - {{customerId}}</span>
      </div>
      <section class="section-btn-menu">
        <button mat-icon-button (click)="openMenu()" class="menu-open-button round-button" [ngClass]="{'missing-pages-note': hasUnfinishedPages}" [disabled]="isLoading">
          <mat-icon>menu</mat-icon>
        </button>
      </section>
    </div>


  </div>
</header>

<div style="position: relative;">
  <div *ngIf="isLoading" class="cdc-loading-overlay">
    <mat-spinner class="cdc-loading-spinner"></mat-spinner>
    <div class="cdc-loading-text">{{ 'Loading' | translate }}</div>
  </div>

  <router-outlet></router-outlet>
</div>

<div class="preview-badge" *ngIf="showPreviewBadge">
  <mat-icon>remove_red_eye</mat-icon>
  <span>{{'Preview' | translate}}</span>
</div>
